import { useTextDomainContext } from "@/app/providers";
import { useContext } from "react";

export const useEnergyTypeArray = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  // We must match the following with GetBuildings query.
  return [
    { value: "electricity", label: gettext("Electricity") },
    { value: "gas", label: gettext("Natural Gas") },
    { value: "energy", label: gettext("Energy"), disabled: true }, // Still need to decide for that.
    { value: "heating", label: gettext("District Heating") }, // Still need to decide for that.
    { value: "water", label: gettext("Water") }, // Still need to decide for that.
    { value: "oil", label: gettext("Oil"), disabled: true }, // We do not have any meter in database
    { value: "lpg", label: gettext("LPG"), disabled: true }, // We do not have any meter in database
    { value: "hydrogen", label: gettext("Hydrogen"), disabled: true }, // We do not have any meter in database
  ];
};
